"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = require("lodash");
var officesList_1 = require("../global/officesList");
function useOfficesOptions() {
    return (0, react_1.useMemo)(function () {
        return (0, lodash_1.map)(officesList_1.globalOfficesData, function (data) {
            return {
                text: data.name,
                value: data.id,
            };
        });
    }, []);
}
exports.default = useOfficesOptions;
